import store from "@/store";
import { ScreenCrud } from "@/js/value-objects/screen-crud";
import { ScreenId } from "@/js/value-objects/screen-id";
import { Screen } from "@/js/value-objects/screen";
import { hasProperty } from "@/js/utils";

const install = Vue => {
  Object.defineProperty(Vue.prototype, "$screenAuthority", {
    get() {
      if (store.getters["screenAuthority/screenAuthority"]) {
        return store.getters["screenAuthority/screenAuthority"];
      }
      return null;
    },
    set(screenAuthority) {
      store.dispatch("screenAuthority/setScreenAuthority", screenAuthority);
      const screenOperationAuthority = screenAuthority.filter(auth => {
        const screenCrud = ScreenCrud.factory(auth.screen_crud);
        const screenId = ScreenId.factory(auth.screen_id);
        return screenCrud.isOperation() && screenId.isOperation();
      });
      store.dispatch(
        "screenAuthority/setScreenOperationAuthority",
        screenOperationAuthority
      );
    }
  });
  Vue.prototype.$hasScreenAuthority = (mainScreenId, screenAuthority) => {
    if (!screenAuthority || !Array.isArray(screenAuthority)) {
      return false;
    }
    return screenAuthority.some(auth => {
      if (!hasProperty(auth, "screen_id")) {
        return false;
      }
      return auth.screen_id.startsWith(mainScreenId);
    });
  };
  Vue.prototype.$screenOperationAuthority = (
    readAuthorityScreenId,
    operationAuthorityScreenId
  ) => {
    let readOnly = true;
    let screenId = readAuthorityScreenId;
    let screenTitle = ScreenId.getScreenTitle(readAuthorityScreenId);
    let hasDeleteAuthority = false;
    if (store.getters["screenAuthority/screenOperationAuthority"]) {
      const screenOperationAuthority =
        store.getters["screenAuthority/screenOperationAuthority"];
      if (
        screenOperationAuthority &&
        Array.isArray(screenOperationAuthority) &&
        screenOperationAuthority.some(
          auth => auth.screen_id === operationAuthorityScreenId
        )
      ) {
        readOnly = false;
        screenId = operationAuthorityScreenId;
        screenTitle = ScreenId.getScreenTitle(screenId);
        const screenAuthority = screenOperationAuthority.find(
          auth => auth.screen_id === operationAuthorityScreenId
        );
        if (ScreenCrud.factory(screenAuthority.screen_crud).isAll()) {
          hasDeleteAuthority = true;
        }
      }
    }
    return Screen.factory(readOnly, screenId, screenTitle, hasDeleteAuthority);
  };
};
export default {
  install
};
